import "core-js/stable";
import "regenerator-runtime/runtime";

require("ninelines-ua-parser");
